// extracted by mini-css-extract-plugin
export default {"sectionLayout":"DashedTitleSection_sectionLayout__D9n2H","sectionHeading":"DashedTitleSection_sectionHeading__Lry9b"};